<script setup>
import AssessmentObjective from '../AssessmentObjective/AssessmentObjective.vue'

const props = defineProps({
  currentCategory: {
    type: Object,
    default: undefined,
  },
  currentStep: {
    type: String,
    default: 'assessment',
  },
  currentAreaTitle: {
    type: String,
    default: '',
  },
  assessmentData: {
    type: Object,
    default: undefined,
  },
  prevCategory: {
    type: Object,
    default: null,
  },
  nextCategory: {
    type: Object,
    default: null,
  },
  evaluationCompleted: {
    type: Boolean,
    default: false,
  },
  ratingCompleted: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'navigate-to-category',
  'go-to-rating',
  'go-to-review',
])

const navigatePrev = () => {
  if (props.prevCategory)
    emit('navigate-to-category', { id: props.prevCategory.id })
}

const navigateNext = () => {
  if (props.nextCategory)
    emit('navigate-to-category', { id: props.nextCategory.id })
}
</script>

<template>
  <div class="AssessmentCategory">
    <span class="AssessmentCategory-subline">{{ currentAreaTitle }}</span>
    <h1 class="AssessmentCategory-headline">
      {{ props.currentCategory.key }} {{ props.currentCategory.title }}
    </h1>

    <ul class="AssessmentCategory-objectives">
      <AssessmentObjective
        v-for="objective in props.currentCategory.objectives"
        :key="objective.id"
        :current-step="props.currentStep"
        :objective="objective"
        :current-category-key="props.currentCategory.key"
        class="AssessmentCategory-objective"
        :assessment-data="props.assessmentData"
      />
    </ul>

    <div class="AssessmentCategory-navigation">
      <button
        v-if="props.prevCategory"
        class="button AssessmentCategory-navigationButton AssessmentCategory-navigationButton--prev"
        @click="navigatePrev"
      >
        <svg class="icon" aria-hidden="true">
          <use href="#arrow-left"></use>
        </svg>
        <span>Zurück</span>
      </button>
      <span v-else class="AssessmentCategory-navigationSpacer" />

      <button
        v-if="props.nextCategory"
        class="button AssessmentCategory-navigationButton AssessmentCategory-navigationButton--next"
        @click="navigateNext"
      >
        <span>Weiter</span>
        <svg class="icon" aria-hidden="true">
          <use href="#arrow-right"></use>
        </svg>
      </button>
      <button
        v-else-if="props.currentStep === 'evaluation'"
        class="button button--primary AssessmentCategory-navigationButton AssessmentCategory-navigationButton--rating"
        :disabled="!props.evaluationCompleted"
        @click="emit('go-to-rating')"
      >
        <span>Zur Bewertung</span>
        <svg class="icon" aria-hidden="true">
          <use href="#arrow-right"></use>
        </svg>
      </button>
      <button
        v-else-if="props.currentStep === 'rating'"
        class="button button--primary AssessmentCategory-navigationButton AssessmentCategory-navigationButton--review"
        :disabled="!props.ratingCompleted"
        @click="emit('go-to-review')"
      >
        <span>Zur Auswertung</span>
        <svg class="icon" aria-hidden="true">
          <use href="#arrow-right"></use>
        </svg>
      </button>
    </div>
  </div>
</template>
